import Router from "next/router";

import { MessageType, TransMsg } from "../i18n/messages";
import { LocaleText } from "../types/locale";

function getLocaleValue(value: LocaleText, locale: string) {
  if (!value) return undefined;

  switch (locale) {
    case "en":
      return value.en ? value.en : value.zhHant ? value.zhHant : value.en;
    case "zh-Hant":
      return value.zhHant ? value.zhHant : value.zhHans ? value.zhHans : value.en;
    case "zh-Hans":
      return value.zhHans ? value.zhHans : value.zhHant ? value.zhHant : value.en;
    default:
      return null;
  }
}

function isNumber(value: any) {
  if (isNaN(value)) {
    return false;
  } else {
    return true;
  }
}

function getFirst(...seq: (string | undefined)[]) {
  for (const item of seq) {
    if (item) return item;
  }
  return "";
}

function getLocaleValueFallback(value: LocaleText | undefined | null, locale: string) {
  if (!value) return "";
  switch (locale) {
    case "en":
      return getFirst(value.en, value.zhHant, value.zhHans);
    case "zh-Hans":
      return getFirst(value.zhHans, value.zhHant, value.en);
    case "zh-Hant":
      return getFirst(value.zhHant, value.zhHans, value.en);
    default:
      return getFirst(value.en, value.zhHant, value.zhHans);
  }
}

function getLocaleValueDefault(value: LocaleText) {
  return getLocaleValue(value, Router.locale ?? "");
}

function getLocaleValueDefaultFallback(value: LocaleText | undefined | null) {
  return getLocaleValueFallback(value, Router.locale ?? "");
}

function getHKD(value: number) {
  const formatter = new Intl.NumberFormat("en-US", {
    currency: "HKD",
    style: "currency",
  });

  if (!value) {
    return undefined;
  }
  return formatter.format(value);
}

function isEmpty(value: LocaleText) {
  if (!value) return false;
  if (!value.en) return false;
  if (!value.zhHans) return false;
  if (!value.zhHant) return false;
  return true;
}

function getLocaleLabel(locale: string, t: (msg: TransMsg) => string, msg: MessageType) {
  switch (locale) {
    case "en":
      return t(msg.setting.english);
    case "zh-Hant":
      return t(msg.setting.chineseT);
    case "zh-Hans":
      return t(msg.setting.chineseS);
  }
}

const localeCore = {
  getHKD,
  getLocaleLabel,
  getLocaleValue,
  getLocaleValueDefault,
  getLocaleValueDefaultFallback,
  isEmpty,
  isNumber,
};

export default localeCore;
